import { render } from "./customCarousel.vue?vue&type=template&id=4617db4b"
import script from "./customCarousel.vue?vue&type=script&lang=js"
export * from "./customCarousel.vue?vue&type=script&lang=js"

import "./customCarousel.vue?vue&type=style&index=0&id=4617db4b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__